import { Injectable } from '@angular/core';
import {Router} from "@angular/router";
import { UserService } from '../user/user.service';

/**
 * AuthGuardService is used to check if the application can activate. The application
 * can only activate if the user is logged in. Otherwise, they are navigated to the login
 * screen
 */
@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {
  /**
   * Default constructor to initalize services 
   * 
   * @param _authService
   * @param _router 
   */
  constructor(
    private _userService: UserService,
    private _router: Router
  ) {}

  /**
   * Attempt to activate the application by checking authentication status
   * 
   * @returns status on if activation was successful
   */
  canActivate(): boolean {
    if (!this._userService.authenticated) {
      console.log(`[LOG]: in auth-guard.service, user not authenticated at '${this._router.url}', navigating to '/login'`)

      this._router.navigate(['/login']);
      return false;
    }

    console.log("[LOG]: in auth-guard.service, user is authenticated")
    return true;
  }
}
